import type { ReactElement } from 'react';

import errorHero from '@/assets/hero/error-hero.png';
import Nav from '@/features/auth/nav.component';
import { AuthContent } from '@/shared/components/layout/auth-content.component';
import { AuthLayout } from '@/shared/components/layout/auth-layout.component';
import { NotFound } from '@/shared/errors/components/not-found.component';

export function NotFoundPage(): ReactElement {
  return (
    <AuthLayout hero={errorHero} nav={<Nav />}>
      <AuthContent>
        <NotFound />
      </AuthContent>
    </AuthLayout>
  );
}
